/**
 * Adds Google Analytics scripts
 */

const addGtagScript = () => {
  const script = document.querySelector('[data-item="analytics-script"]')

  if (script) {
    script.src = script.getAttribute('data-src')
  }

  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }

  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    security_storage: 'granted',
    wait_for_update: 5000,
  })
  gtag('js', new Date())

  gtag('config', 'UA-120231338-1')
}

addGtagScript()

const updateAnalytics = () => {
  console.log('updateAnalytics')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }

  gtag('consent', 'update', {
    analytics_storage: 'granted',
  })
}

const updateAds = () => {
  console.log('updateAds')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    personalization_storage: 'granted',
  })
}

const updatePreferences = () => {
  console.log('updatePreferences')
  window.dataLayer = window.dataLayer || []

  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('consent', 'update', {
    functionality_storage: 'granted',
  })
}

/**
 * Starts Google Analytics on bw-cookies-action event if Analyticks cookies are accepted
 */
window.addEventListener('bw-cookies-action', () => {
  if (window.CookiesController) {
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-analytics')
    ) {
      updateAnalytics()
    }
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-marketing')
    ) {
      updateAds()
    }
    if (
      window.CookiesController.isCookieAccepted('bw-cookie-google-preferences')
    ) {
      updatePreferences()
    }
    window.removeEventListener('bw-cookies-action', this)
  }
})
